import clsx from 'clsx';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import ImageWithFallback from 'components/ImageWithFallback';
import Link from 'next/link';
import { HOMEPAGE_BUCKET_LINK } from 'utils/image/bucketLinks';
import DrawCounter from '../DrawCounter';
import { EnterButton } from '../enter-button/EnterButton';
import styles from './HeroSection.module.css';

export const HeroSection = ({
  isSubscriber,
  nextDrawDate,
}: {
  isSubscriber: boolean;
  nextDrawDate: string;
}) => {
  return (
    <div className={styles.heroWrapper}>
      {/* Background Image */}
      <ImageWithFallback
        layout="fill"
        objectFit="cover"
        src={`${HOMEPAGE_BUCKET_LINK}/homepage-hero.jpg`}
        width={1920}
        height={1080}
        className={styles.heroImage}
        alt="Hero Background"
      />
      {/* Gradient Overlay */}
      <div className={styles.gradientOverlay} />
      <AboutUsSiteContainer>
        <div className={styles.heroSection}>
          {/* Draw Counter */}
          {/* add Draw Counter to the design system file */}
          {/* fix draw counter issue with padding pusshing white background */}

          <div className={styles.drawCounterContainer}>
            <div>
              <DrawCounter targetDate={new Date(nextDrawDate)} />
            </div>
          </div>

          {/* Title & Subtitle */}
          <div className={styles.titleSection}>
            <h2
              className={`aboutUsTypographyHeaderXlarge ${styles.heroText} ${styles.heroTitle}`}
            >
              Win prizes that <br /> make your day
            </h2>
            <p
              className={clsx(
                'aboutUsTypographyHeaderMedium',
                'noMargin',
                styles.heroText,
              )}
            >
              Dream holidays, home renovations <br className="mobileOnly" />& so
              much more
            </p>

            {!isSubscriber && <EnterButton />}

            {/* Logos */}
            <div className={styles.heroContent}>
              <div className={styles.logoContainer}>
                <Link href="/giving-back">
                  <div className={styles.givingBackImage}>
                    <ImageWithFallback
                      src={`${HOMEPAGE_BUCKET_LINK}/giving-back-hero.svg`}
                      width={256}
                      height={256}
                      alt="Giving Back"
                    />
                  </div>
                </Link>
                <Link
                  href="https://uk.trustpilot.com/review/daymade.co.uk"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className={styles.trustpilotImageContainer}>
                    <ImageWithFallback
                      src={`${HOMEPAGE_BUCKET_LINK}/trustpilot-hero.webp`}
                      width={128}
                      height={99}
                      alt="Trustpilot"
                      className={styles.trustpilotImage}
                    />
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </AboutUsSiteContainer>
    </div>
  );
};
